import { createReducer } from '@reduxjs/toolkit';
import { updateChoices } from '../actions';

const availableChoices = createReducer({},
  (builder) => {
    builder.addCase(updateChoices, (state, action) => ({ ...state, ...action.payload }));
  }
);
export default availableChoices;